import axios from 'axios'
import { objectToURLSearchParams } from '@/utils/index'
import router from '../router/index'
import user from '../store/modules/user'

// 判断用户类型   安全学习0  专项学习1 道理运输2

const service = axios.create({
  baseURL: window.baseapi.baseApiUrl,
  timeout: 20000 // 请求超时时间
})
service.interceptors.request.use(config => {
  config.params = objectToURLSearchParams(config.params)
  var pfc = sessionStorage.getItem('platform');
  if (pfc === '0') {
    config.baseURL = window.baseapi.baseApiUrl
  } else if (pfc === '1') {
    config.baseURL = window.baseapi.ZXbaseApiUrl
  } else if (pfc === '2') {
    config.baseURL = window.baseapi.DLbaseApiUrl
  } else if (pfc === '3') {
    config.baseURL = window.baseapi.AQXXbaseApiUrl
  } else if (pfc === '4') {
    config.baseURL = window.baseapi.LLRYbaseApiUrl
  } 
  config.headers = {
    'content-type': 'application/json',
    'token': user.state.token
  }
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    console.log('拦截器returnCode' + response.data.returnCode)
    if (response.data.returnCode === -2) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('platform')
      sessionStorage.removeItem('stuId')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('sex')
      sessionStorage.removeItem('phone')
      sessionStorage.removeItem('photo')
      sessionStorage.removeItem('userId')
      sessionStorage.removeItem('companyId')
      sessionStorage.removeItem('professionId')
      sessionStorage.removeItem('professionName')
      sessionStorage.removeItem('IdCard')
      sessionStorage.removeItem('driverNumber')
      sessionStorage.removeItem('companyName')
      sessionStorage.removeItem('register')
      sessionStorage.removeItem('CertificateNo')
      // Toast('账号已在别处登录,重新登录')
      router.replace({
        path: '/'
      })
    }
    return response
  },
  error => {
    var errmsg = error.message
    // console.log('拦截器erro=' + error.response.message)
    // AbpUI 返回的错误消息处理
    if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
      errmsg = error.response.data.error.message
    }
    console.log('err' + errmsg)// for debug
    // Message({
    //   message: '请求出现异常，请联系管理人员，异常为：' + errmsg,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js